//Backside of the jobsite card, shown if the worker is a foreman. 
import React, { useState } from "react";
import { FiArrowLeft, FiSend, FiSmartphone } from "react-icons/fi";
import KyoskModal from "./KyoskModal";
import ForemanAddWorkerModal from "./ForemanAddWorkerModal";
import ModalPortal from "./ModalPortal";

const ForemanJobsiteCard = ({ jobSite, onBackClick }) => {
  const [showKyoskModal, setShowKyoskModal] = useState(false);
  const [showAddWorkerModal, setShowAddWorkerModal] = useState(false);

  return (
    <div className="rounded-xl border border-stone-200 bg-white p-4 shadow-sm">
      <div className="relative flex items-center mb-4 h-8">
        <button
          onClick={onBackClick}
          className="z-10 inline-flex items-center rounded-md border border-stone-300 bg-white px-2 py-1 text-xs font-medium text-stone-700 transition hover:bg-stone-100"
        >
          <FiArrowLeft className="mr-1 h-4 w-4" />
          Back
        </button>
        <h2 className="absolute left-1/2 top-1/2 m-0 -translate-x-1/2 -translate-y-1/2 text-center text-lg font-semibold tracking-tight text-stone-900">
          {jobSite.jobsiteName}
        </h2>
      </div>
      <div className="flex flex-col gap-4">
        <button
          className="inline-flex items-center justify-center gap-2 rounded-md bg-stone-900 py-2 text-sm font-medium text-white transition hover:bg-stone-800"
          onClick={() => setShowKyoskModal(true)}
        >
          <FiSmartphone className="h-4 w-4" />
          Kyosk
        </button>
        <button className="inline-flex items-center justify-center gap-2 rounded-md border border-stone-300 bg-white py-2 text-sm font-medium text-stone-800 transition hover:bg-stone-100" onClick={() => setShowAddWorkerModal(true)}>
          <FiSend className="h-4 w-4" />
          Send Invitation
        </button>
      </div>
      {showKyoskModal && (
        <KyoskModal onClose={() => setShowKyoskModal(false)} jobsiteId={jobSite.id} />
      )}
      {showAddWorkerModal && (
        <ModalPortal>
          <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50">
            <div className="relative w-full max-w-lg rounded-xl bg-white p-4 shadow-2xl">
              <ForemanAddWorkerModal onClose={() => setShowAddWorkerModal(false)} />
            </div>
          </div>
        </ModalPortal>
      )}
    </div>
  );
};

export default ForemanJobsiteCard;
